import React from 'react';
import Helmet from 'react-helmet';
import View from '../components/View';
import ContactView from '../components/ContactView';
import FooterView from '../components/FooterView';

const MentionsLegales = props => (
  <div>
    <Helmet
      title="Mentions Légales - Com des Lézards"
    />
    <View colorMode="2">
      <div style={{ padding: '20px', fontFamily: 'Bree Serif' }}>
        <h1>Mentions Légales</h1>
        <p>
        Le site comdeslezards.com est édité pas COM DES LEZARDS, société à responsabilité limitée au capital de 16 000,00 €, et immatriculée sous le numéro RCS Toulon B 438 033 367.
          <br />
          <br />
        Siège social : 54 avenue des îles d'or, 83400 Hyères
          <br />
        Numéro de TVA intracommunautaire : FR 82 438 033 367
          <br />
        Email : team@comdeslezards.com
          <br />
        Téléphone : +33 7 66 89 09 21
        </p>
        <h3>Directeur de la publication :</h3>
        <p>Benjamin Fille</p>
        <h3>Hébergement du site :</h3>
        <p>AMEN SASU, 12-14, Rond Point des Champs Elysées 75008 Paris</p>
        <p>
Le Service Client est joignable du Lundi au Vendredi de 9h à 19h au 0811 88 77 66 (0,06 € / min + prix de l'appel).
          <br />
Le Service Commercial est joignable du Lundi au Vendredi de 9h à 19h au 0811 88 77 66 (0,06 € / min + prix de l'appel).
        </p>
      </div>

      <FooterView />
    </View>
  </div>

);

export default MentionsLegales;



// WEBPACK FOOTER //
// ./src/pages/mentions-legales.jsx